import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { ProGetWhatsappInfoQuery, ProGetWhatsappInfoQueryVariables } from '@gql/graphql';
import { useMemo } from 'react';

export const PRO_GET_WHATSAPP_INFO = graphql(`
  query ProGetWhatsappInfo($where: ProfessionalWhereInput!) {
    searchProfessionals(take: 1, where: $where) {
      professionals {
        id
        whatsappNumber
        type
        imgs(take: 1) {
          id
          small
        }
        translations {
          id
          language
          title
        }
      }
    }
  }
`);

export const useGetPro = (id?: number) => {
  const variables = useMemo((): ProGetWhatsappInfoQueryVariables => {
    return {
      where: {
        id: { equals: id },
      },
    };
  }, [id]);

  const { data, error, loading } = useQuery<
    ProGetWhatsappInfoQuery,
    ProGetWhatsappInfoQueryVariables
  >(PRO_GET_WHATSAPP_INFO, {
    variables,
    skip: !id,
  });

  return {
    pro: data?.searchProfessionals.professionals?.[0],
    proError: error,
    proLoading: loading,
  };
};
